export default __webpack_public_path__ + "static/media/menu_arrow.c0f30acd.svg";